// extracted by mini-css-extract-plugin
export default {"uiIconRoot":"UIIcon_uiIconRoot__hPWlr","iconMedium":"UIIcon_iconMedium__DLCA2"};